import { render } from "./MainLayout.vue?vue&type=template&id=45cbcc16"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/student/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45cbcc16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45cbcc16', __exports__)) {
    api.reload('45cbcc16', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=45cbcc16", () => {
    api.rerender('45cbcc16', render)
  })

}


export default __exports__